export default __webpack_public_path__ + "beta-maps-guides-streets-1200-00c1a98f94c773a2c2529a9adfd552a8.png";